<template>
  <v-main>
    <div id="save-question-paper-button" class="text-center">
      <v-btn @click="printPdf" class="mt-3" color="primary">Save Question Paper as PDF</v-btn>
    </div>
    <v-container v-if="!currentUser.is_student">
      <div class="edit_test">
        <div>
          <TestDescription :test="test" v-if="!isLoading && test" />
          <TestQuestionForm
            v-if="isUpcoming && test"
            v-on:uploadDetails="uploadDetails"
            :key="uniqueKey"
          />
          <div v-for="question in questions" :key="question.id">
            <QuestionCard
              :question="question"
              :showDelete="isUpcoming"
              @deleteQuestion="deleteQuestionFromList"
            />
          </div>
        </div>
      </div>
    </v-container>
    <v-snackbar v-model="snackbar.showSnackbar">
      {{ snackbar.snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar.showSnackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>
<script>
import TestDescription from "../../components/tests/TestDescription.vue";
import TestQuestionForm from "../../components/tests/TestQuestionForm.vue";
import QuestionCard from "../../components/tests/QuestionCard.vue";
import { mapGetters, mapActions } from "vuex";
import testsApi from "@api/tests/all_tests";
import Helper from "@utils/misc";
import api from '@api/index';
import endpoints from '@api/repository';
import moment from "moment";
// import jsPDF from "jspdf";
// import "jspdf-autotable";


export default {
  name: "EditTest",
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrors: this.handleErrors,
      }
    },
    // checks if test is ongoing
    isOngoing() {
      return (
        moment(new Date(this.test.start_datetime * 1000)).isBefore(
          moment(new Date())
        ) &&
        moment(new Date(this.test.end_datetime * 1000)).isAfter(
          moment(new Date())
        )
      );
    },
    // checks if this.test is upcoming
    isUpcoming() {
      return moment(new Date(this.test.start_datetime * 1000)).isAfter(
        moment(new Date())
      );
    },
    // calculate timestamp 
    startDateTime: function() {
      var d = new Date(this.test.start_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    },
    endDateTime: function() {
      var d = new Date(this.test.end_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    },
  },
  data() {
    return {
      test: null,
      questions: [],
      snackbar: {
        snackbarText: "",
        showSnackbar: false
      },
      uniqueKey: Helper.uuidv4()
    };
  },

  methods: {
    ...mapActions(["setLoading", "unsetCurrentUser"]),
    async getTestDetails() {
      this.test = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.getTestDetails + this.$route.params.tid + '/',
        responseVar: this.test,
      });
    },

    // uploads question data to server
    async uploadDetails(questionData) {
      // send to server
      this.setLoading(true);
      this.snackbar.snackbarText = "This may take some time. Do not close";
      this.snackbar.showSnackbar = true;

      let questionResponse = await testsApi.uploadQuestionDetails(
        this.accessToken,
        questionData
      );
      // check for errors
      if (!Helper.handleErrors(questionResponse, this.handleErrors)) return;
      // if no, refresh questionsList
      if (questionResponse) {
        this.questions.unshift(questionResponse);
        this.uniqueKey = Helper.uuidv4();
        this.test.questions_count++;
        this.test.marks += questionResponse.marks;
        this.snackbar.snackbarText = "Question Added!";
        this.snackbar.showSnackbar = true;
      }
      this.setLoading(false);
    },
    // get already created questions of the test
    async getTestQuestions() {
      this.questions = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.getTestQuestions + this.$route.params.tid + '/',
        responseVar: this.questions,
      });
    },

    getOptionString(options){
      var optionString = ''
      options.map((option) => {
        optionString += `• ${option.op}\n`
      })
      return optionString;
    },

    async printPdf(){
      this.hideElementsForPrinting();
      print();
      this.showElementsForPrinting();

    },

    hideElementsForPrinting() {
      document.getElementById('app-bar-toolbar').style.display = "none";
      document.getElementById('save-question-paper-button').style.display = "none";
      var questionCards = document.getElementsByClassName('saved-question-card');
      for (var i = 0; i<questionCards.length;i++){
        questionCards[i].style.boxShadow = "none";
      }
    
    },


    showElementsForPrinting(){
      document.getElementById('app-bar-toolbar').style.display = "block";
      document.getElementById('save-question-paper-button').style.display = "block";
       var questionCards = document.getElementsByClassName('saved-question-card');
       for (var i = 0; i<questionCards.length;i++){
        questionCards[i].style.boxShadow = "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)";
      }
     
      
    },

    // async printPdf(){
    //   this.setLoading(true);
    //   var doc = new jsPDF();

    //   // Stats header
    //   let detailsHeader = ["Test Name", "Subject", "Test Date", "Marks"];
    //   var detailRow = [
    //     this.test.tname,
    //     `${this.test.subject.name} - ${this.test.subject.room.sections}` ,
    //     `${this.startDateTime}-${this.endDateTime}`,
    //     this.test.marks,
    //   ];
    //   doc.autoTable(detailsHeader, [detailRow], {
    //     startY: 10,
    //     styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] }
    //   });

    // // Questions
    //   var quesRows =  []
    //   let quesHeaders = ["Question","Options","Correct Answer", "Marks"];
    //   this.questions.forEach(element => {
    //     var temp = [
    //       element.qtext,
    //       element.is_subjective ? "*SUBJECTIVE" : this.getOptionString(element.options),
    //       element.options.find((option) => option.is_correct)?.op ?? "-",
    //       element.marks,
    //     ];
    //     quesRows.push(temp);
        
    //   });

    //   doc.autoTable(quesHeaders, quesRows, {startY: 30,});


    //   // doc.autoTable(columnHeader, rows, { startY: 30 });
    //   var pdfName = this.test.tname
    //   doc.save(pdfName + ".pdf");
    //   this.setLoading(false);

    // },

    // delete question from server
    async deleteQuestionFromList(question) {
      this.setLoading(true);
      let deleteResponse = await testsApi.deleteQuestion(
        this.accessToken,
        question.id
      );
      if (!Helper.handleErrors(deleteResponse, this.handleErrors)) return;
      if (deleteResponse)
        this.questions = this.questions.filter(q => q.id != question.id);
      this.test.questions_count--;
      this.test.marks -= question.marks;
      this.snackbar.snackbarText = "Question Deleted!";
      this.snackbar.showSnackbar = true;
      this.setLoading(false);
    },

    // handles API Errors
    handleErrors(err) {
      this.setLoading(false);
      if (err.response.status == 405) {
        this.$router.push("/restricted");
      }
    }
  },
  async created() {
    if (this.currentUser.is_student) return;
    this.getTestDetails();
    this.getTestQuestions();
  },
  components: {
    TestDescription,
    TestQuestionForm,
    QuestionCard
  }
};
</script>
